import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AddEvaluationFormWidget from '../../../widgets/evaluationForm/AddEvaluationFormWidget'
import { getAssessmentConfigForm } from '../../../redux/actions/assessment'
import { isEmpty } from 'lodash-es'

export default function AddEvaluationForm() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const assessmentId = sessionStorage.getItem('assessmentId')

  useEffect(() => {
    handleGetSchema(assessmentId)
  }, [assessmentId])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentConfigForm(assessmentId)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi />
      <AddEvaluationFormWidget schema={schema} isAddNew={isEmpty(assessmentId) ? true : false} />
    </SidebarProposal>
  )
}
